<div class="page-content page-fill">
  <div class="card mb-3">
    <div class="card-body">
      @if (filter) {
        <dx-form [formData]="filter" style="max-width: 400px;" [colCount]="1">
          <dxi-item dataField="givingYear" [label]="{ text: 'Giving Year' }" editorType="dxSelectBox" [editorOptions]="{ items: givingYears }"></dxi-item>
          @if (!appInfo.graafschap) {
            <dxi-item dataField="rmd" [label]="{ text: 'RMD Contributions'}" editorType="dxCheckBox"></dxi-item>
          }
        </dx-form>
      }
    </div>
  </div>
  <div class="grid-fill">
    <dx-data-grid #familiesGrid [dataSource]="families" keyExpr="id" [wordWrapEnabled]="true" [rowAlternationEnabled]="false" (onToolbarPreparing)="onToolbarPreparing($event)">
      <dxi-column dataField="name" [width]="250" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="displayAddress" caption="Address" [width]="400"></dxi-column>
      <dxi-column dataField="created" format="shortDateShortTime" width="200px"></dxi-column>

      <dxo-sorting mode="multiple"></dxo-sorting>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-remote-operations [sorting]="true" [filtering]="true"></dxo-remote-operations>
      <dxo-selection mode="single"></dxo-selection>
      <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="familiesGrid"></dxo-state-storing>
      <dxo-search-panel [visible]="true"></dxo-search-panel>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <button
          (click)="printStatement(familiesGrid.instance.getSelectedRowsData()[0].id)"
          [hidden]="!canPrintStatement"
          [disabled]="familiesGrid.instance.getSelectedRowsData().length === 0"
          class="btn btn-primary me-3"
          >
          Create Statement
        </button>
        <button (click)="printYearlyStatement()" [hidden]="!canPrintStatement" class="btn btn-danger">All Statements</button>
      </div>
    </dx-data-grid>
  </div>
</div>
